import { Pipe, PipeTransform } from "@angular/core";
import humanizeDuration from "humanize-duration";

type TimeUnit = "millisecond" | "second" | "minute" | "hour";

@Pipe({
    name: "humanizeDuration",
})
export class HumanizeDurationPipe implements PipeTransform {
    transform(value: number, timeUnit: TimeUnit = "second", language: string): any {
        return humanizeDuration(this.toMillis(value, timeUnit), { language: language ?? 'en' })
    }

    toMillis(value: number, timeUnit: TimeUnit) {

        switch (timeUnit) {
            case "second":
                return value * 1000;
            case "minute":
                return value * 60 * 1000;
            case "hour":
                return value * 60 * 60 * 1000;
            default:
                return value;
        }

    }


}